import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-right text-nowrap" }

import { usePayslipItems } from '@/core/composables/salaries/usePayslipItems'
import { formatMoney } from '@spl-company-oy/core'
import { toRefs } from 'vue'

interface Props {
  /** Array of payslip items */
  items: PayslipItem[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PayslipItemSummary',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props

const { items } = toRefs(props)

const { highlightedItems } = usePayslipItems(items)

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(highlightedItems), (payslipItem) => {
    return (_openBlock(), _createElementBlock("div", {
      key: payslipItem.name,
      class: _normalizeClass(["flex flex-row justify-between gap-x-1", { highlight: payslipItem.highlight }])
    }, [
      _createElementVNode("span", null, _toDisplayString(payslipItem.display_name) + " " + _toDisplayString(payslipItem.percent), 1),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(formatMoney)(payslipItem.amount)), 1)
    ], 2))
  }), 128))
}
}

})